export default __webpack_public_path__ + "static/media/32.2dcfd318.jpeg";